import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const BreadcrumbContext = createContext(null);

export const BreadcrumbProvider = ({ children }) => {
  const [stack, setStack] = useState([]);

  const currentView = stack[stack.length - 1]?.key;

  const initStack = useCallback((root) => {
    setStack([root]);
  }, []);

  const pushView = useCallback((frame) => {
    setStack((prev) => [...prev, frame]);
  }, []);

  const popTo = useCallback((index) => {
    setStack((prev) => prev.slice(0, index + 1));
  }, []);

  const reset = useCallback(() => {
    setStack([]);
  }, []);

  const value = useMemo(
    () => ({ stack, currentView, pushView, popTo, reset, initStack }),
    [stack, currentView, pushView, popTo, reset, initStack]
  );

  return (
    <BreadcrumbContext.Provider value={value}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbContext = () => {
  const context = useContext(BreadcrumbContext);

  if (!context) {
    throw new Error('useBreadcrumbContext must be used within BreadcrumbProvider');
  }

  return context;
};
